import React from "react";
import { Skeleton } from "@ebscois/react-component-library";
import { SkeletonContainer } from "./_.styled";

const ContentSectionSkeleton = ({ isAnimated = true }) => {
  return (
    <SkeletonContainer data-testid="content-section-skeleton">
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
      <Skeleton kind="text" rag animate={isAnimated} />
    </SkeletonContainer>
  );
};

ContentSectionSkeleton.displayName = "ContentSectionSkeleton";
export default ContentSectionSkeleton;
